<template>
	<div class="chat-header" :style="dataType != 2 ? '' : 'height: 70px;'">
		<div class="title" :style="dataType != 2 ? '' : 'height: 100%;'">
			{{ info.nickname }}
			<symbolIcon class="icon-right" :name="dataType == 1 ? 'messenger' : 'whatsapp'"></symbolIcon>
			<span class="subtitle" v-if="info.followupName">跟进人:&nbsp;{{ info.followupName }}</span>

			<!-- <span
				class="subtitle blue"
				v-if="newOrold && !info.followupName"
				@click="
					() => {
						this.assign_visible = true;
					}
				"
				>点击分配跟进人</span
			> -->
			<el-tooltip style="white-space: pre-line" placement="top" v-if="garbageInfo.garbageFlag">
				<div slot="content" style="white-space: pre-line; max-width: 250px">
					<!---->{{ garbageInfo.garbageReason
					}}<!---->
				</div>
				<span class="content-hint"> 疑 </span>
			</el-tooltip>
		</div>
		<div class="subtitle" v-if="dataType != 2">
			消息来自{{ info.sourceTypeStr }}
			<span v-if="info.sourceContent && info.sourceType != 10"
				>:&nbsp;{{ info.sourceContent }}</span
			>
			<span v-if="info.sourceType == 10">
				:&nbsp;
				<a :href="oldPageUrl" target="_blank">{{ oldPageUrl }}</a>
			</span>
		</div>
		<assignFollowUp
			:summaryId="id"
			:visible.sync="assign_visible"
			:messengerUserId="messengerUserId"
			v-bind="$attrs"
		>
		</assignFollowUp>
	</div>
</template>
<script>
import assignFollowUp from '@/components/chat/components/assign-follow-up.vue';
import symbolIcon from '@/components/iglobalwin/ig-icon/symbolIcon.vue';
export default {
	props: {
		info: null,
		id: null,
		messengerUserId: null,
		dataType: null,
		garbageInfo: null,
	},
	data() {
		return {
			assign_visible: false,
		};
	},
	filters: {
		sourceFilter(val) {
			if (val == 2 || val == 3) {
				return '网页即时聊天';
			}
			if (val == 1) {
				return 'Facebook广告';
			}
			if (val == 10) {
				return '公共主页';
			}
		},
	},
	computed: {
		oldPageUrl() {
			return 'https://facebook.com/' + this.info.pageId;
		},
		routeName() {
			return this.$route.name == 'chat' ? false : true;
		},
		newOrold() {
			return this.$route.name !== 'liveChat';
		},
	},
	methods: {},
	components: {
		assignFollowUp,
		symbolIcon,
	},
};
</script>
<style lang="scss" scoped>
.chat-header {
	height: 90px;
	padding-left: 30px;
	border-bottom: 1px #e8e8e8 solid;
	.title {
		font-size: 22px;
		font-weight: 500;
		color: #333333;
		padding: 15px 0px 10px 0px;
		display: flex;
		align-items: center;
	}
	.subtitle {
		font-size: 14px;
		font-weight: 400;
		color: #666666;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.blue {
		color: #3da1ff;
		cursor: pointer;
	}
	.icon-right {
		font-size: 22px;
		margin: 0 12px;
	}

	.content-hint {
		height: 25px;
		width: 25px;
		border-radius: 4px;
		border: 1px solid rgba(255, 197, 61, 1);
		color: #ffc53d;
		font-size: 13px;
		margin-left: 10px;
		user-select: none;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>
